import { all, fork, call, put, takeLatest } from 'redux-saga/effects';

import { loadAPI } from 'services/google';
import { loadAuth2, initAuth2 } from 'services/google/auth2';
import { GOOGLE_API_LOAD, GOOGLE_AUTH2_API } from './types';
import {
  googleApiLoadSuccess,
  googleApiLoadFailure,
  googleAuth2LoadSuccess,
  googleAuth2LoadFailure,
  googleAuth2InitSuccess,
  googleAuth2InitFailure,
} from './actions';

export function* loadGoogleAPI() {
  try {
    yield call(loadAPI);
    yield put(googleApiLoadSuccess());
  } catch (error) {
    yield put(googleApiLoadFailure());
  }
}

export function* workerLoadAuth2() {
  try {
    yield call(loadAuth2);
    yield put(googleAuth2LoadSuccess());
  } catch (error) {
    yield put(googleAuth2LoadFailure());
  }
}

export function* workerInitAuth2() {
  try {
    yield call(initAuth2);
    yield put(googleAuth2InitSuccess());
  } catch (error) {
    yield put(googleAuth2InitFailure());
  }
}

export function* workerAuth2Ready() {
  // yield delay(2000);
  // yield put(loginRequest());
}

export function* watchGoogleAPIsLoad() {
  yield takeLatest(GOOGLE_API_LOAD.SUCCESS, workerLoadAuth2);

  yield takeLatest(GOOGLE_AUTH2_API.LOAD_SUCCESS, workerInitAuth2);
  yield takeLatest(GOOGLE_AUTH2_API.INIT_SUCCESS, workerAuth2Ready);
}

export default function* googleSagas() {
  yield all([fork(loadGoogleAPI), fork(watchGoogleAPIsLoad)]);
}
